import React from 'react';
import '../css.css';

/**
 * 관리자 전용 유저 설정 조회 패널 컴포넌트
 * @param {Object} props
 * @param {Array} props.allUsers - 전체 유저 목록
 * @param {string} props.selectedUserId - 선택된 유저 ID
 * @param {Function} props.onUserSelect - 유저 선택 핸들러
 * @param {Array} props.selectedUserSettings - 선택된 유저의 설정 목록
 * @param {string} props.selectedUserSettingId - 선택된 유저의 설정 ID
 * @param {Function} props.onSettingSelect - 설정 선택 핸들러
 * @param {string} props.settingType - 설정 타입 ('레시피' 또는 '채비')
 */
const AdminSettingsPanel = ({
  allUsers,
  selectedUserId,
  onUserSelect,
  selectedUserSettings,
  selectedUserSettingId,
  onSettingSelect,
  settingType = '레시피'
}) => {
  return (
    <div className="admin-panel saved-settings-panel">
      <div className="settings-controls">
        <label>관리자 전용: 유저 {settingType} 조회</label>
        <div className="settings-row">
          <div className="load-settings">
            <select
              value={selectedUserId}
              onChange={(e) => onUserSelect(e.target.value)}
              className="settings-select"
            >
              <option value="">-- 유저 선택 --</option>
              {allUsers.map(user => (
                <option key={user.user_id} value={user.user_id}>
                  {user.username} ({user.settings_count}개)
                </option>
              ))}
            </select>
          </div>
          
          <div className="load-settings">
            <select
              value={selectedUserSettingId}
              onChange={(e) => onSettingSelect(e.target.value)}
              className="settings-select"
              disabled={!selectedUserId}
            >
              <option value="">-- {settingType} 선택 --</option>
              {selectedUserSettings.map(setting => (
                <option key={setting.id} value={setting.id}>
                  {setting.saved_name || setting.name} ({new Date(setting.updated_at).toLocaleDateString()})
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSettingsPanel;
